export default __webpack_public_path__ + "static/michigan-4-99af691475b75165f800f19e0649ac76.jpg";